import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoatourpackagesforfamily() {



const cardData =
{
  keyword: 'Pune to Goa Tour Packages for Family',

  heading: 'Lotus Cab: Pune to Goa Tour Packages for Family ',

headingDescription:
  "Lotus Cabs offers customized Pune to Goa Tour Packages for Family designed for a comfortable, safe, and memorable holiday experience. Our family tour packages include convenient cab travel, flexible sightseeing options, and hassle-free transportation throughout your Goa trip. Choose from our premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs. Whether you are planning a beach vacation, family outing, sightseeing tour, or a relaxing getaway, Lotus Cabs provides 24x7 booking support, transparent pricing, doorstep pickup from Pune, well-maintained vehicles, and smooth travel arrangements for a perfect Pune to Goa family tour.",


  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
    {
        title: "Grand Island",
        description:
            "Grand Island is one of Goa's most popular adventure destinations, famous for snorkeling, scuba diving, fishing, and exploring vibrant marine life. Surrounded by crystal-clear waters of the Arabian Sea, the island offers an exciting experience for adventure seekers and nature lovers."
    },
    {
        title: "Cotigao Wildlife Sanctuary",
        description:
            "Cotigao Wildlife Sanctuary is one of Goa's oldest wildlife reserves, known for dense forests, diverse wildlife, and beautiful natural landscapes. Visitors can explore walking trails, spot animals and birds, and enjoy the peaceful environment away from crowded tourist areas."
    },
    {
        title: "Netravali Wildlife Sanctuary",
        description:
            "Netravali Wildlife Sanctuary is a hidden gem in South Goa, famous for lush green forests, waterfalls, trekking routes, and rich biodiversity. The sanctuary offers a refreshing experience for travelers interested in nature, photography, and wildlife exploration."
    },
    {
        title: "Kakolem Beach",
        description:
            "Kakolem Beach, also known as Tiger Beach, is a secluded coastal paradise surrounded by cliffs and greenery. Its untouched beauty, peaceful atmosphere, and scenic views make it one of Goa's best offbeat beach destinations."
    },
    {
        title: "Betul Beach",
        description:
            "Betul Beach is a quiet fishing village beach in South Goa known for its serene coastline, traditional seafood, and beautiful sunset views. The peaceful surroundings make it perfect for travelers looking to experience authentic Goan culture."
    },
    {
        title: "Cabo de Rama Fort",
        description:
            "Cabo de Rama Fort is a historic fort located on a cliff overlooking the Arabian Sea. Famous for its spectacular ocean views, ancient architecture, and peaceful surroundings, it is an excellent destination for history lovers and sunset photography."
    },
    {
        title: "Salaulim Dam",
        description:
            "Salaulim Dam is a scenic attraction surrounded by lush greenery and natural landscapes. The unique spillway design, peaceful reservoir, and beautiful gardens make it a relaxing destination for families and nature enthusiasts."
    },
    {
        title: "Hollant Beach",
        description:
            "Hollant Beach is a calm and less crowded beach near Vasco da Gama, known for its shallow waters, peaceful environment, and stunning sunrise views. It is an ideal spot for swimming, photography, and enjoying a relaxing coastal experience."
    },
    {
        title: "Kesarval Spring",
        description:
            "Kesarval Spring is a natural spring near Cortalim known for its scenic surroundings and traditional importance. Surrounded by greenery, the location offers visitors a peaceful escape and a chance to explore Goa's natural attractions."
    },
    {
        title: "Palácio do Deão",
        description:
            "Palácio do Deão is a historic Portuguese-style heritage mansion located in Quepem, Goa. Known for its beautiful architecture, riverside gardens, and cultural significance, the palace offers visitors a glimpse into Goa's colonial-era lifestyle and traditions."
    }
],





"services": [
  {
    "name": "Pune to Goa Tour Packages for Family",
    "description": "Book Pune to Goa tour packages for family and enjoy a comfortable vacation with customized travel plans, sightseeing, and convenient cab services. Packages are designed for families looking for a relaxing beach holiday with spacious vehicles, experienced drivers, and flexible itineraries. Choose from one-way, round-trip, and multi-day tour options with comfortable accommodation and sightseeing arrangements."
  },
  {
    "name": "Pune to Goa Family Tour Package",
    "description": "Pune to Goa family tour package offers a perfect getaway for families seeking a memorable beach vacation. Travel in comfortable AC vehicles with professional drivers and enjoy customized itineraries covering famous beaches, forts, churches, and popular tourist attractions. Suitable for families with children and senior citizens."
  },
  {
    "name": "Pune to Goa Family Cab Package",
    "description": "Book Pune to Goa family cab package for a hassle-free road trip with spacious vehicles like Ertiga and Innova Crysta. The package includes comfortable travel, flexible pickup timings, and sightseeing options, making it ideal for family vacations, long weekends, and holiday trips."
  },
  {
    "name": "Pune to Goa Holiday Package",
    "description": "Enjoy a memorable vacation with Pune to Goa holiday package designed for couples, families, and groups. The package includes comfortable transportation, customized itineraries, and sightseeing opportunities to explore Goa's beautiful beaches, markets, and historical attractions at your own pace."
  },
  {
    "name": "Pune to Goa Vacation Package",
    "description": "Pune to Goa vacation package offers a relaxing and enjoyable travel experience with comfortable cab services and flexible tour plans. Perfect for families and friends looking for a stress-free holiday with convenient transportation and optional sightseeing arrangements."
  },
  {
    "name": "Pune to Goa Tour by Cab",
    "description": "Book Pune to Goa tour by cab and enjoy the freedom of traveling at your own pace. Professional drivers, clean AC vehicles, and customized travel schedules make this package ideal for family vacations, sightseeing trips, and weekend getaways."
  },
  {
    "name": "Pune to Goa Family Taxi Package",
    "description": "Pune to Goa family taxi package is specially designed for comfortable group travel with spacious vehicles and experienced chauffeurs. Enjoy convenient pickup and drop services along with customized sightseeing plans for a memorable family vacation."
  },
  {
    "name": "Pune to Goa Weekend Tour Package",
    "description": "Plan a short escape with Pune to Goa weekend tour package featuring comfortable cab travel and flexible itineraries. Ideal for long weekends and mini vacations, the package allows families and groups to explore Goa's beaches and tourist attractions without travel stress."
  },
  {
    "name": "Pune to Goa 2 Days Family Package",
    "description": "Pune to Goa 2 days family package is perfect for a quick beach holiday with comfortable transportation and customized travel schedules. The package includes convenient cab services and enough time to explore Goa's major attractions and enjoy quality family time."
  },
  {
    "name": "Pune to Goa 3 Days Family Package",
    "description": "Enjoy an extended vacation with Pune to Goa 3 days family package that covers popular beaches, sightseeing spots, and leisure activities. Spacious vehicles and experienced drivers ensure a comfortable and memorable travel experience for the entire family."
  },
  {
    "name": "Goa Family Packages from Pune",
    "description": "Goa family packages from Pune offer complete travel solutions for families seeking a relaxing and enjoyable holiday. Choose from customized packages with comfortable transportation, sightseeing, and flexible travel durations to create unforgettable memories."
  },
  {
    "name": "Pune to Goa Sightseeing Package",
    "description": "Pune to Goa sightseeing package includes convenient cab services and visits to famous beaches, churches, forts, and local markets. Ideal for families and groups wanting to explore Goa comfortably with experienced drivers and personalized itineraries."
  },
  {
    "name": "Pune to Goa Tour Package by Car",
    "description": "Book Pune to Goa tour package by car and enjoy a personalized travel experience with flexible departure times and sightseeing options. Choose from sedan, Ertiga, and Innova vehicles according to your family size and travel requirements."
  },
  {
    "name": "Best Pune to Goa Family Tour",
    "description": "Best Pune to Goa family tour package offers comfortable transportation, professional drivers, and customized itineraries for an unforgettable holiday experience. Ideal for families looking for a stress-free vacation with sightseeing, beach visits, and flexible travel arrangements."
  }
],

"tableData": [
  ["Pune to Goa Tour Packages for Family", "Pune to Goa Family Tour Package"],
  ["Pune to Goa Family Cab Package", "Pune to Goa Holiday Package"],
  ["Pune to Goa Vacation Package", "Pune to Goa Tour by Cab"],
  ["Pune to Goa Family Taxi Package", "Pune to Goa Weekend Tour Package"],
  ["Pune to Goa 2 Days Family Package", "Pune to Goa 3 Days Family Package"],
  ["Goa Family Packages from Pune", "Pune to Goa Sightseeing Package"],
  ["Pune to Goa Tour Package by Car", "Best Pune to Goa Family Tour"]
],






"whychoose": [
  {
    "WhyChooseheading": "Perfect Family Vacation Packages",
    "WhyChoosedescription": "Enjoy a memorable Goa trip with specially designed tour packages for families from Pune."
  },
  {
    "WhyChooseheading": "Comfortable Family Vehicles",
    "WhyChoosedescription": "Choose spacious Ertiga, Innova Crysta, and SUV options for a comfortable family journey."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans",
    "WhyChoosedescription": "Flexible tour packages that can be tailored according to your family's schedule and preferences."
  },
  {
    "WhyChooseheading": "Affordable Package Pricing",
    "WhyChoosedescription": "Budget-friendly family tour packages with transparent costs and no hidden charges."
  },
  {
    "WhyChooseheading": "Doorstep Pickup from Pune",
    "WhyChoosedescription": "Convenient pickup service from homes, apartments, hotels, and any location in Pune."
  },
  {
    "WhyChooseheading": "Safe and Relaxing Journey",
    "WhyChoosedescription": "Professional drivers ensure a secure and enjoyable trip for families traveling with children and seniors."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Options",
    "WhyChoosedescription": "Book a complete Goa vacation package with flexible return plans to suit your itinerary."
  },
  {
    "WhyChooseheading": "24/7 Travel Assistance",
    "WhyChoosedescription": "Dedicated support team available to help with bookings, package details, and travel arrangements."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab offer Pune to Goa tour packages for families?',
    answer: 'Yes, Lotus Cab provides customized Pune to Goa family tour packages with comfortable vehicles and flexible travel options.'
  },
  {
    question: 'Which vehicles are suitable for family trips to Goa?',
    answer: 'Families can choose from Ertiga, Innova Crysta, and spacious SUVs depending on the number of passengers and luggage requirements.'
  },
  {
    question: 'What is the distance from Pune to Goa?',
    answer: 'The road distance between Pune and Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours.'
  },
  {
    question: 'Can I customize my family tour package?',
    answer: 'Yes, our family packages can be customized based on your travel dates, duration of stay, and vehicle preferences.'
  },
  {
    question: 'Are round-trip family packages available?',
    answer: 'Yes, we offer both one-way and round-trip Goa tour packages for families traveling from Pune.'
  },
  {
    question: 'Do you provide pickup from home in Pune?',
    answer: 'Yes, Lotus Cab offers doorstep pickup services from residential areas, hotels, airports, and railway stations in Pune.'
  },
  {
    question: 'Are toll and parking charges included in the package?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically mentioned in the package details.'
  },
  {
    question: 'Is the journey suitable for children and senior citizens?',
    answer: 'Yes, our spacious vehicles and experienced drivers ensure a comfortable and safe journey for passengers of all age groups.'
  },
  {
    question: 'Can I book a multi-day Goa family package?',
    answer: 'Absolutely. We provide customized packages for weekend getaways and extended family vacations in Goa.'
  },
  {
    question: 'How can I book Pune to Goa Tour Packages for Family with Lotus Cab?',
    answer: 'Simply share your travel date, number of family members, pickup location, and preferred vehicle to receive package details and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sonali Deshmukh',
    feedback: 'Taking our parents and children to Goa required a spacious and comfortable vehicle. Lotus Cab arranged everything perfectly and the trip became one of our favorite family vacations.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Ketan Kulkarni',
    feedback: 'We wanted a stress-free Goa tour package for our family and the service exceeded our expectations. The driver was patient, the vehicle was clean, and everyone enjoyed the journey.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Tour Packages for Family",
"image": "https://lotuscab.com/assets/images/pune-to-goa-tour-packages-for-family.jpg",
"description": "Book Pune to Goa Tour Packages for Family with Lotus Cab for a comfortable and memorable holiday. Enjoy family cab packages, weekend trips, vacation tours, and private taxi services with sedan, Ertiga, Innova, and SUV cabs driven by professional drivers available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-tour-packages-for-family"
}
};






  return (
    <div>
      

<Helmet>
  <title>Pune to Goa Tour Packages for Family | Family Cab Package | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Tour Packages for Family with Lotus Cab. Enjoy affordable family holiday packages, weekend tours, vacation trips, and private cab services with professional drivers and comfortable AC taxis."
/>

<meta
 name="keywords"
 content="Pune to Goa Tour Packages for Family, Pune to Goa Family Tour Package, Pune to Goa Family Cab Package, Pune to Goa Holiday Package, Pune to Goa Vacation Package, Pune to Goa Tour by Cab, Pune to Goa Family Taxi Package, Pune to Goa Weekend Tour Package, Pune to Goa 2 Days Tour Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoatourpackagesforfamily;